module.exports = __webpack_public_path__ + "img/42741593507939_.pic_hd.732a61de.png";